import { render } from "./pos-profile.vue?vue&type=template&id=080966c0&scoped=true"
import script from "./pos-profile.vue?vue&type=script&lang=js"
export * from "./pos-profile.vue?vue&type=script&lang=js"

import "./pos-profile.vue?vue&type=style&index=0&id=080966c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-080966c0"]])

export default __exports__